import { Box, Paper, Stack, Skeleton } from "@mui/material";

export const ChartSkeleton = () => {
  return (
    <Paper sx={{ marginTop: "8px" }}>
      <Stack
        flexDirection={"row"}
        justifyContent="space-between"
        alignItems={"center"}
        padding={2}
      >
        <Stack
          direction="column"
          justifyContent="space-between"
          alignItems="left"
        >
          <Skeleton variant="text" width={150} height={15} /> {/* Impression Share */}
          <Skeleton variant="text" width={150} height={15} /> {/* Average competitors text */}
        </Stack>
        <Skeleton 
          variant="rounded" 
          width={272} 
          height={40} 
          sx={{ borderRadius: 1 }} 
        /> {/* Autocomplete */}
      </Stack>
      <Box>
        <Stack sx={{ width: "100%", display: "flex", margin: "0 auto", padding: 2 }}>
          <Skeleton 
            variant="rectangular" 
            width="100%" 
            height={400}
            animation="wave"
            sx={{ 
              margin: { top: 10, bottom: 30 },
              padding: { top: 2, bottom: 50,},
              borderRadius: 1
            }}
          />
        </Stack>
      </Box>
    </Paper>
  );
};
